import { v4 as uuidv4 } from 'uuid';

export function uuid(): string {
  return uuidv4().replace(/-/g, '').toLowerCase();
}
/**
 * Dates used to be stored as JS Date objects, instead convert to ISO 8601 strings.
 * That way they work with ionic date picker
 *
 * @export
 * @param {(Date | string)} date
 * @param {Date} defaultDate
 * @returns {string}
 */
export function prepareDate(date: Date | string, defaultDate: Date): string {
  let d;
  if (!date) {
    d = defaultDate;
  } else if (date instanceof Date) {
    d = date;
  } else {
    d = new Date();
    d.setTime(Date.parse(date));
  }
  return d ? d.toISOString() : d;
}

// https://medium.com/front-end-hacking/today-i-learned-memoization-with-pure-functions-in-es6-33a4765518b5
export function memoize(fn) {
  const cache = {};
  return (...args) => {
    const stringifiedArgs = JSON.stringify(args);
    const result = (cache[stringifiedArgs] =
      cache[stringifiedArgs] || fn(...args));
    return result;
  };
}

// http://stackoverflow.com/a/4878800/457935
export function toCapCase(txt: string): string {
  return txt.charAt(0).toUpperCase() + txt.substring(1).toLowerCase();
}
